module.exports = __webpack_public_path__ + "static/media/sc12.1611f759.svg";